export const VALUE_CHANGED = 'VALUE_CHANGED';
export const TOGGLE_STATE_CHANGED = 'TOGGLE_STATE_CHANGED';
export const ADD_OPTION_CLICKED = 'ADD_OPTION_CLICKED';
export const SORT_OPTIONS = 'SORT_OPTIONS_ASC';
export const REORDER_OPTIONS = 'REORDER_OPTIONS';
export const REMOVE_ALL_OPTIONS = 'REMOVE_ALL_OPTIONS';
export const REMOVE_OPTION = 'REMOVE_OPTION';
export const OPTION_EXPANDED = 'OPTION_EXPANDED';
export const DEFAULT_VALUE_CHANGED = 'DEFAULT_VALUE_CHANGED';
export const TRANSLATION_VALUE_CHANGED = 'TRANSLATION_VALUE_CHANGED';
export const IS_NOT_EMPTY = 'IS NOT EMPTY';
export const ENABLE = 'Enable';
export const DISABLE = 'Disable';
export const UNDEFINED = 'undefined';
export const UNDERSCORE = '_';
export const LEFT_BRACKET_CHAR = '[';
export const RIGHT_BRACKET_CHAR = ']';
export const PIPE_CHAR = '|';
export const IDS_KEY = 'ids';
export const VALUES_KEY = 'values';
export const VALUE_KEY = 'value';
export const ISSUES = 'issues';
export const VALUE_LEVEL_1_KEY = 'value_level1';
export const VALUE_LEVEL = 'value_level';
export const IS_ENABLED = 'isEnabled';
export const CHILDREN = 'children';
export const KEY = 'key';
export const TRANSLATION_KEY = 'translation';
export const LEVEL_NAME_KEY = 'levelName';
export const LEVEL_NAME_TRANSLATION_KEY = 'levelNameTranslation';
export const LEVEL_DESCRIPTION_KEY = 'levelDescription';
export const LEVEL_DESCRIPTION_TRANSLATION_KEY = 'levelDescriptionTranslation';
export const NEW_LINE_CHARACTER = '\n';
export const COPY_ID_TO_CLIPBOARD_TEXT = 'Option ID copied to clipboard.';
export const SAVE_OPTIONS_SUCCESS_MESSAGE = 'Options saved successfully.';
export const SAVE_OPTIONS_FAILED_MESSAGE = 'Saving failed. Please try again.';
export const GET_FIELD_CONFIG_FAILED_MESSAGE = 'Getting field configuration failed. Please try again';
export const CANCEL_SUCCESS_MESSAGE = 'Changes have been cancelled.';
export const OPTIONS_REMOVED_SUCCESS_MESSAGE = 'Option removed from configuration and issues.';
export const CHANGE_SORT_DIRECTION_TOOLTIP_TEXT = 'Reverse sort direction';
export const BULK_OPTIONS_PLACEHOLDER_TEXT = 'Copy-paste / enter your options here';
export const BULK_OPTIONS_INFO_TEXT =
    'Type in each option in separate line. Use Enter to jump to next line. Remember that option’s name must be unique.';
export const SAVE_STATE_AFTER_OPTION_NAME_UPDATED_MESSAGE =
    "You've just changed some options names. Save them before continuing.";

export const IMPORT_SUCCESS_MESSAGE = 'Success! All configuration imported!';
export const UPDATE_OPTION_NAME_SUCCESS_MESSAGE = 'Updates have been saved successfully.';
export const ACTION_REQUIRED_TITLE = 'Action required';
export const TRANSLATIONS_LANGUAGE_SELECT_DESCRIPTION = 'Select language into which you want to translate this option.';
export const SETTINGS_SAVED_SUCCESS_MESSAGE = 'Settings have been saved successfully.';
export const SETTINGS_SAVED_FAILURE_MESSAGE = 'There were problems with saving settings.';
export const TREE_DATA_WITH_LEVELS_INFO_CONFIG_MODEL = '2';
export const LEVEL_INFO_DESCRIPTION_LINK_REGEX =
    '(\\[[^(?:[^|]+\\|https?:\\/\\/((?!www\\.))?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b[-a-zA-Z0-9()@:%_\\+.~#?&\\/\\/=]*\\])|(.[^\\[]*)';
export const NO_OPTION_INDEX = -1;
export const TOP_OF_THE_TREE = 0;
export const FIRST_NESTING_LEVEL = 1;
export const REPLACE_ONE_ELEMENT = 1;
export const REMOVE_ONE_ELEMENT = 1;
export const MINIMUM_ROWS = 6;
export const MAX_NESTING_LEVEL = 7;
export const CANCEL_TRIGGERED = true;
export const SAVE_TO_STORAGE = true;
export const PARENTS_UPDATE = true;
export const STRAIGHT_UPDATE = true;
export const DATA_FOR_VIEW_LOADED = true;
export const MULTI_OPTION_SEARCH = true;
export const VALUE_UPDATE = true;
export const MANUAL_CHANGE = true;
export const IS_TRANSLATION_UPDATE = true;
export const IS_IN_SELECT_CONTEXT = true;
export const IS_LEVEL_NAME_SEARCH = true;
export const IS_IN_TAB_CONTEXT = true;
export const IS_LEVEL_NAME_TRANSLATION_SEARCH = true;
export const IS_LEVEL_NAME_TRANSLATION = true;
export const OPTION_TO_DELETE_DEFAULTS = {
    optionValue: '',
    optionKey: '',
    optionIndex: -1,
};
export const LEVELS_INFO_DEFAULTS = { _1: [], _2: [], _3: [], _4: [], _5: [], _6: [], _7: [] };
export const LEVELS_INFO_TEXTS = {
    levelNameHeader: 'Level name (optional)',
    levelNameDescription: 'Give the level a name',
    levelDescriptionHeader: 'Description (optional)',
    levelDescriptionText:
        'Tell your users how they should use this field. Links are available (format: [link name|http://example.com]).',
};
